module.exports = {
  leaving_soon_ms: 1000 * 60 * 60 * 24
};
